import React from "react";
import { inject, observer } from 'mobx-react';
import { withStyles } from "@material-ui/core/styles";
import Dialog from "../../../components/Dialog/Dialog";
import {
  DialogTitle,
  DialogContent,
  Fab,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import PageTitle from "../../../components/PageTitle/PageTitle";
import ButtonLong from "../../../components/Button/ButtonLong";
import Button from "../../../components/Button/Button";
import MultiToggleButtons from "../../../components/Button/MultiToggleButtons";
import CamposProntuario from "./CamposProntuario";
import BotoesProntuario from "./ButtonsProntuario";
import { findProfissionalSaudeLogado } from "../../../services/UsuarioService";

const tabs = {
  BARRA_ATALHOS: 0,
  BOTOES: 1
}


@inject("prontuarioStore", "sujeitoAtencaoStore")
@observer
class PersonalizarCamposProntuario extends React.Component {
  constructor(props) {
    super(props);
    this.refModelDocumentEditor = React.createRef();

    this.state = {
      loadingButtonSave: false,
      allCampoProntuarioList: [],
      selectedCampoProntuarioList: [],
      tabSelected: tabs.BARRA_ATALHOS,
    };
  }

  async componentDidMount() {
    let allCampoProntuarioList = await this.props.prontuarioStore.findAllCampoProntuario();
    this.refresh();

    const camposSelecionadosProps = this.props.selectedCamposProntuario;
    const listaTodosCamposProntuarios = allCampoProntuarioList.map(
      (campoProntuario) => {
        campoProntuario.checked = camposSelecionadosProps.some(
          (selecionado) =>
            campoProntuario.campo === selecionado.campoProntuario.campo
        );
        if (
          campoProntuario.campo === "ALTURA" ||
          campoProntuario.campo === "PESO"
        ) {
          campoProntuario.disabled = true;
        }
        return campoProntuario;
      }
    );

    this.setState({ allCampoProntuarioList: listaTodosCamposProntuarios });

    const camposSelecionados = listaTodosCamposProntuarios.filter(
      (campoProntuario) => campoProntuario.checked
    );
    this.setState({ selectedCampoProntuarioList: camposSelecionados });
  }

  openFeedback = (message, type) => {
    const {isProntuario} = this.props;

    isProntuario ? this.props.sujeitoAtencaoStore.openNotification(message, type) :
      this.props.prontuarioStore.openNotification(message, type)
  }

  handleClickSave = async () => {
    this.setState({ loadingButtonSave: true });
    try {
      await this.props.prontuarioStore.updateFiltroCampoProntuarioProfissionalSaudeLogado(
        this.state.selectedCampoProntuarioList
      );
      this.props.updateSelectedCamposProntuario(
        this.state.selectedCampoProntuarioList
      );
      await this.props.prontuarioStore.findAllCampoProntuarioByProfissionalSaudeLogadoList();
    } catch (error) {
      this.openFeedback("Erro ao salvar alterações", "error");
    } finally {
      this.setState({ loadingButtonSave: false });
      this.props.handleClose();
    }
  };

  refresh = async () => {
    await this.props.prontuarioStore.findAllButtonsProntuario();
  }

  handleSaveBotoes = async () => {
    this.setState({ loadingButtonSave: true });

    try {
      const variables = {
        botoesProntuario: this.props.prontuarioStore.botoesProntuario,
      };
      await this.props.prontuarioStore.updateBotoesProntuarioProfissional(
        variables
      );
      this.openFeedback("Salvo!", "success");
      this.refresh()
    } catch (error) {
     this.openFeedback(
        "Erro ao salvar alterações",
        "error"
      );
      
    } finally {
      this.setState({ loadingButtonSave: false });
      this.props.handleClose();
    }
  };

  handleChangeCampoProntuarioList = (selectedCampoProntuarioList) => {
    this.setState({
      selectedCampoProntuarioList,
    });
  };

  handleChangeCheckbox = (campoProntuario) => {
    if (
      this.state.selectedCampoProntuarioList.length > 7 &&
      !campoProntuario.checked
    ) {
      return;
    }

    campoProntuario.checked = !campoProntuario.checked;
    const camposSelecionados = this.state.allCampoProntuarioList.filter(
      (campoProntuario) => campoProntuario.checked
    );
    this.setState({ selectedCampoProntuarioList: camposSelecionados });
  };

  handleChangeTab = (tabSelected) => {
    this.setState({ tabSelected: tabSelected });
  };

  renderTab = ({ classes }) => {
    const { allCampoProntuarioList } = this.state;

    switch (this.state.tabSelected) {
      case tabs.BOTOES:
        return <BotoesProntuario hiddenProcedimentosButton={this.props.hiddenProcedimentosButton}/>;
      default:
        return (
          <CamposProntuario
            allCampoProntuarioList={allCampoProntuarioList}
            selectedCampoProntuarioList={this.state.selectedCampoProntuarioList}
            handleChangeCampoProntuarioList={
              this.handleChangeCampoProntuarioList
            }
            handleChangeCheckbox={this.handleChangeCheckbox}
          />
        );
    }
  };

  render() {
    const { classes, open, handleClose } = this.props;
    const { tabSelected } = this.state;
    return (
      <>
        <PageTitle title="Editar barra de atalhos" />
        <Dialog
          classes={{ scrollPaper: classes.scrollPaper, paper: classes.paper }}
          maxWidth="md"
          open={open}
          onClose={handleClose}
          fullWidth
        >
          <DialogTitle
            classes={{ root: classes.dialogHeader }}
            disableTypography
          >
            <div className={classes.dialogTitle}>
              <div className={classes.dialogTitleName}>
                <h1>Editar barra de atalhos</h1>
              </div>
              <div>
                <Fab
                  id="prt-pcp-btn-fch"
                  className={classes.buttonActionClose}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </Fab>
              </div>
            </div>
            <MultiToggleButtons
              id="prt-pcp-btn-tab"
              tabSelected={0}
              changeTabSelected={(e) => this.handleChangeTab(e)}
              options={["Campos Prontuario", "Botões Prontuario"]}
            />
          </DialogTitle>
          <DialogContent className={classes.dialogContentBorder}>
            {this.renderTab({ classes })}
          </DialogContent>
          <div className={classes.wrapperFooter}>
            <ButtonLong
              id="prt-pcp-btn-cnc"
              onClick={handleClose}
              colorCustom="transparency"
              className={classes.buttonCancel}
            >
              Cancelar
            </ButtonLong>
            <Button
              id="prt-pcp-btn-slv"
              onClick={
                tabSelected === 0 ? this.handleClickSave : this.handleSaveBotoes
              }
              colorCustom="green"
              className={classes.buttonSave}
              loading={this.state.loadingButtonSave}
              disabled={this.state.loadingButtonSave}
            >
              Salvar
            </Button>
          </div>
        </Dialog>
      </>
    );
  }
}

export default withStyles(theme => ({
  root: {
    position: "relative",
    overflow: "none",
    zIndex: 1
  },
  paper: {
    borderRadius: 35,
    overflow: "unset",
    height: 630,
  },
  dialogHeader: {
    background: 'white',
    borderRadius: '15px',
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    padding: '1rem 1rem 0.5rem',
  },
  dialogTitleName: {
    display: 'flex',
    alignItems: 'center',
    '& > h1': {
      color: '#333333',
      fontSize: '18px',
      fontWeight: 'bold',
      marginLeft: '8px'
    },
  },
  dialogContentBorder: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#F9F9F9',
    padding: '1rem',
    borderRadius: '0 0 15px 15px',
  },
  camposProntuarioDisponiveis: {
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    height: "300px",
    border: "1px solid " + theme.palette.commons.gray3,
    marginTop: "20px",
    padding: "20px",
    borderRadius: '8px',
  },
  buttonActionClose: {
    backgroundColor: "#FB7676",
    width: '40px',
    height: '40px',
    color: 'white',
    marginLeft: 10
  },
  tuneIcon: {
    width: '1em',
    height: '1em',
    color: "#26ACA9",
  },
  wrapperFooter:{
    display: 'flex',
    padding: '1rem',
    backgroundColor: '#F1F1F3',
    '& > button': {
      flex: 1,
      margin: '0 0.5rem',
    },
  },
  buttonCancel:{
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  buttonSave:{
    backgroundColor: '#26ACA9',
    boxShadow: 'none',
    borderRadius: "100px",
    height: 32,
    width: "100%",
    border: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  
    textTransform: "capitalize",
  },
  content:{
    display: 'flex',
    width: '100%',
    height: '100%'
  },
}))(PersonalizarCamposProntuario);
